import {mainQuery} from '@github-ui/react-core/future/main-query'
import {dashboardSurfaceAppBuilder} from '../config/app-builder'
import {PULLS_PATH} from '../constants/routes'
import {queryResolver} from '../helpers/query-resolver'

import type {PullsDashboardStateCountSurfacePayload} from '../types/routes-types'

export const pullsDashboardSurfaceContentRoute = dashboardSurfaceAppBuilder.createQueryRouteConfig(
  'pullsDashboardSurfaceContentRoute',
  {
    path: `${PULLS_PATH}/:mode`,
    queries: [
      mainQuery<PullsDashboardStateCountSurfacePayload>({
        queryDeps: ({searchParams, params}: {searchParams: URLSearchParams; params: {mode?: string}}) => {
          const q = queryResolver({searchParams, params})
          const result = {
            pathname: PULLS_PATH,
            searchParams: {q, page: searchParams.get('page') || '1'},
          }
          return result
        },
      }),
    ],
  },
)
